import useSWR from "swr";
import { useSDK } from "@contentful/react-apps-toolkit";
import { FetchProps, GlossaryLocalePair, swrKeys } from "../lib";
import { getPlanFromCredentials } from "../utils";
import { GlossaryLocalesResponse } from "./types";

const DeeplGlossaryLocalesFetcher = async (credentials: string): Promise<GlossaryLocalePair[]> => {
    const plan = getPlanFromCredentials(credentials);

    const response = await fetch(`/api/${plan}/v2/glossary-language-pairs`, {
        method: "GET",
        headers: {
            Authorization: `DeepL-Auth-Key ${credentials}`,
            Connection: "keep-alive",
        },
    });

    if (!response.ok) {
        throw new Error(`Error fetching DeepL glossary languages. Status: ${response.status}`);
    }

    const data: GlossaryLocalesResponse = await response.json();

    const languages: GlossaryLocalePair[] = data.supported_languages.map(pair => {
        return {
            source: pair.source_lang.toUpperCase(),
            target: pair.target_lang.toUpperCase(),
        };
    });

    return languages;
};

export const useFetchDeeplGlossaryLocales = (props?: FetchProps) => {
    const { skip } = props ?? {};
    const sdk = useSDK();
    const deeplCredentials = sdk.parameters.installation.deeplApiKey;

    const { data, isLoading } = useSWR(
        [swrKeys.deeplGlossaryLocales, deeplCredentials, !!skip],
        () => (!skip ? DeeplGlossaryLocalesFetcher(deeplCredentials) : undefined)
    );

    return {
        data,
        isLoading,
    };
};
